// import BarraOpcoes from "../childrens/BarraOpcoes";
import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from '@material-ui/icons/Edit';

export default [
    {
        label: "Código Condição pagamento",
        name: "CD_PAGTO",
        options: {
            display: false,
            filter: true,
            download: true,
            viewColumns: true,
        },
    },
    {
        label: "Nome da Condição",
        name: "NM_COND_PAGTO",
        options: {
            display: true,
            filter: true,
            download: true,
            viewColumns: true,
        },
    },
    {
        label: "Condição Padrão Atrelada",
        name: "NM_COND_PAGTO_PADRAO",
        options: {
            display: true,
            filter: true,
            download: true,
            viewColumns: true,
        },
    },
    {
        label: "Prazo de Atendimento",
        name: "NR_DIAS_PRAZO",
        options: {
            display: true,
            filter: true,
            download: true,
            viewColumns: true,
        },
    },
    {
        label: "Percentual Desconto",
        name: "VP_DESCONTO",
        options: {
            display: true,
            filter: true,
            download: true,
            viewColumns: true,
        },
    },
    {
        label: "Condição Padrão",
        name: "IN_COND_PADRAO",
        options: {
            display: true,
            filter: true,
            download: true,
            viewColumns: true,
        },
    },
    {
        name: "Ações",
        options: {
            display: true,
            filter: false,
            download: false,
            viewColumns: false,
            customBodyRender: (value, tableMeta, updateValue) => {
                return (
                    <Tooltip title={"Editar item"}>
                        <a
                            href={`#/manutencaoCondicoesPagamento-ae/${tableMeta.rowData[0]}`}
                            style={{ color: "#6b61ff" }}
                        >
                            <EditIcon />
                        </a>
                    </Tooltip>
                );
            },
        },
    },
];
